import React, { useState } from 'react';
import { FiSave, FiBell, FiMail } from 'react-icons/fi';
import { HiOutlineCheck, HiOutlineArrowSmRight } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';

const NotificationSettings = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState({
    emailSettings: {
      enabled: true,
      fromEmail: '',
      fromName: '',
    },
    notificationTemplates: {
      welcome: '',
      paymentSuccess: '',
      courseEnrollment: '',
    },
    scheduledNotifications: true,
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.includes('.')) {
      const [section, field] = name.split('.');
      setSettings(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: type === 'checkbox' ? checked : value
        }
      }));
    } else {
      setSettings(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // هنا سيتم إضافة منطق حفظ الإعدادات لاحقاً
      // Save notification settings
    } catch (error) {
      // Handle settings save error
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="border-b border-gray-200 dark:border-gray-700">
        <div className="px-6 py-4 flex justify-between items-center">
          <h2 className="text-lg font-medium text-gray-900 dark:text-white">إعدادات الإشعارات</h2>
          <div className="flex items-center gap-1">
            <button
              onClick={() => navigate('/admin/dashboard/settings')}
              className="group relative p-1 text-slate-400 hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-300"
            >
              <HiOutlineArrowSmRight className="w-5 h-5" />
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs px-2 py-1 rounded-md whitespace-nowrap right-1/2 transform translate-x-1/2">
                رجوع للإعدادات
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1 border-4 border-transparent border-t-gray-900"></div>
              </span>
            </button>
            <button
              onClick={handleSubmit}
              className="group relative p-1 text-emerald-600 hover:text-emerald-700 dark:text-emerald-500 dark:hover:text-emerald-400"
            >
              <HiOutlineCheck className="w-5 h-5" />
              <span className="absolute bottom-full mb-2 hidden group-hover:block bg-gray-900 text-white text-xs px-2 py-1 rounded-md whitespace-nowrap right-1/2 transform translate-x-1/2">
                حفظ التغييرات
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1 border-4 border-transparent border-t-gray-900"></div>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="p-6">
        <form onSubmit={handleSubmit} className="space-y-8">
          {/* إعدادات البريد الإلكتروني */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                <FiBell className="w-5 h-5 text-blue-600 dark:text-blue-400" />
              </div>
              <h3 className="text-lg font-medium">إعدادات البريد الإلكتروني</h3>
            </div>
            
            <div className="space-y-6">
              {/* تفعيل الإشعارات وجدولة الإشعارات */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-center gap-4">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      name="emailSettings.enabled"
                      checked={settings.emailSettings.enabled}
                      onChange={handleInputChange}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:bg-blue-600 after:content-[''] after:absolute after:top-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 dose-toggle-fix dose-toggle-clean"></div>
                  </label>
                  <div>
                    <h4 className="font-medium">تفعيل إشعارات البريد الإلكتروني</h4>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      name="scheduledNotifications"
                      checked={settings.scheduledNotifications}
                      onChange={handleInputChange}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-checked:bg-green-600 after:content-[''] after:absolute after:top-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 dose-toggle-fix dose-toggle-clean"></div>
                  </label>
                  <div>
                    <h4 className="font-medium">جدولة الإشعارات</h4>
                  </div>
                </div>
              </div>

              {/* معلومات البريد */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <div>
                  <label htmlFor="fromEmail" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    البريد الإلكتروني المرسل
                  </label>
                  <input
                    type="email"
                    id="fromEmail"
                    name="emailSettings.fromEmail"
                    value={settings.emailSettings.fromEmail}
                    onChange={handleInputChange}
                    className="input-base"
                    placeholder="example@domain.com"
                    dir="ltr"
                  />
                </div>

                <div>
                  <label htmlFor="fromName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    اسم المرسل
                  </label>
                  <input
                    type="text"
                    id="fromName"
                    name="emailSettings.fromName"
                    value={settings.emailSettings.fromName}
                    onChange={handleInputChange}
                    className="input-base"
                    placeholder="اسم الموقع"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* قوالب الإشعارات */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg">
                <FiMail className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
              </div>
              <h3 className="text-lg font-medium">قوالب الإشعارات</h3>
            </div>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
                <label htmlFor="welcomeTemplate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  رسالة الترحيب
                </label>
                <textarea
                  id="welcomeTemplate"
                  name="notificationTemplates.welcome"
                  value={settings.notificationTemplates.welcome}
                  onChange={handleInputChange}
                  rows={3}
                  className="input-base resize-none"
                  placeholder="أدخل نص رسالة الترحيب..."
                />
              </div>

              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4">
                <label htmlFor="paymentTemplate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  تأكيد الدفع
                </label>
                <textarea
                  id="paymentTemplate"
                  name="notificationTemplates.paymentSuccess"
                  value={settings.notificationTemplates.paymentSuccess}
                  onChange={handleInputChange}
                  rows={3}
                  className="input-base resize-none"
                  placeholder="أدخل نص رسالة تأكيد الدفع..."
                />
              </div>

              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 lg:col-span-2">
                <label htmlFor="enrollmentTemplate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  التسجيل في دورة
                </label>
                <textarea
                  id="enrollmentTemplate"
                  name="notificationTemplates.courseEnrollment"
                  value={settings.notificationTemplates.courseEnrollment}
                  onChange={handleInputChange}
                  rows={3}
                  className="input-base resize-none"
                  placeholder="أدخل نص رسالة التسجيل في دورة..."
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotificationSettings;
